import flatpickr from "flatpickr";

export const datepicker = () => {

	let els = document.querySelectorAll('[data-datepicker]')

	if (!els.length || window.innerWidth < 782) return

	els.forEach(el => {
		flatpickr(el, {
			dateFormat: "Y-m-d",
			altInput: true,
			altFormat: "F j, Y",
			minDate: "today",
			// defaultDate: "today"
		})
	})
}

export default () => { }
